import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJQuickSelectionBox from '../../../../common/components/FJQuickSelectionBox/FJQuickSelectionBox';
import FJUtil from '../../../../util/FJUtil';
import { MOUSE_EVENT_TYPE } from '../../../FJMainPreview/FJCreationEditPanel/js/FJViewCanvas';
import { useCallback, memo, useMemo } from 'react';
import FJActionBrushEditCommon from '../../../../redux/action/FJActionBrushEditCommon';
import FJConfig from '../../../../config/FJConfig';
import FJConstant from '../../../../constants/FJConstant';

const FJObjectEraseQuickSelectionBoxContainer = memo(function FJObjectEraseQuickSelectionBoxContainer() {
    useLocalStore();

    const dispatch = useDispatch();
    const curBrushType = useSelector(state => state.brushEditCommon.curBrushType);
    const isMove = useSelector(state => state.brushEditCommon.isMouseMove);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const aiMaskActive = useSelector(state => state.brushEditCommon.aiMaskActive);

    const isDisabled = useMemo(() => {
        return FJUtil.isGeneratingStatus(taskStatus) || taskStatus === FJConstant.ERROR;
    }, [taskStatus]);

    const quickSelectionSelect = useMemo(() => {
        return !isMove && curBrushType === MOUSE_EVENT_TYPE.QUICK_SELECTION;
    }, [isMove, curBrushType]);

    const selectQuickSelection = useCallback(async () => {
        dispatch(FJActionBrushEditCommon.setCurBrushTypeAction(MOUSE_EVENT_TYPE.QUICK_SELECTION));
    }, [dispatch]);

    const changeQuickSelectionActive = useCallback(
        value => {
            dispatch(FJActionBrushEditCommon.setAiMaskActive(value));
        },
        [dispatch],
    );

    return (
        <FJQuickSelectionBox
            isDisabled={isDisabled}
            quickSelectionActive={aiMaskActive}
            quickSelectionSelect={quickSelectionSelect}
            changeQuickSelectionActive={changeQuickSelectionActive}
            selectQuickSelection={selectQuickSelection}
            tipsTitle='auto-selection'
            tipsText='please-click-to-select-the-object-to-remove-from-the-image'
            tipsPreviewImg={FJConfig.quickSelectionTipImgUrl}
            tipsPreviewVideo={FJConfig.quickSelectionTipVideoUrl}
        />
    );
});

export default FJObjectEraseQuickSelectionBoxContainer;
